import type {
  ContainerElement,
  TextBlockElement
} from "../../../utils/backend-types";
import type { EdgeData, NodeData } from "../StructureViewFlowDiagram.types";
import { getFlowNodesFromContainers } from "./getFlowNodesFromContainers";
import { getFlowNodesFromNodes } from "./getFlowNodesFromNodes";
import { getFlowNodesFromTextBlocks } from "./getFlowNodesFromTextBlocks";

// casts node.data.type to string, since the API returns values other than ObjectName
const nodeType = (node: NodeData) => node.data.type as string;

/**
 * Splits API sketch nodes by type (Container, Freitext, custom) and converts
 * each group into the corresponding ReactFlow node format. Returns an empty
 * array when nodes or edges are undefined (e.g. incomplete API responses).
 */
export function convertAllNodesToFlowNodes(
  nodes: Array<NodeData> | undefined,
  edges: Array<EdgeData> | undefined,
  siteId: number
) {
  if (!nodes || !edges) {
    return [];
  }

  const containerNodes = nodes.filter(
    (node) => nodeType(node) === "Container"
  ) as unknown as Array<ContainerElement>;
  const textNodes = nodes.filter(
    (node) => nodeType(node) === "Freitext"
  ) as unknown as Array<TextBlockElement>;
  const customNodes = nodes.filter(
    (node) => nodeType(node) !== "Container" && nodeType(node) !== "Freitext"
  );
  const newContainerNodes = getFlowNodesFromContainers(containerNodes, siteId);
  const newCustomNodes = getFlowNodesFromNodes(customNodes, edges);
  const newTextNodes = getFlowNodesFromTextBlocks(textNodes, siteId);

  return [...newContainerNodes, ...newCustomNodes, ...newTextNodes];
}
